<script>
import defineAbilitiesFor from "@/config/abilities";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { INITIAL_EVENTS, createEventId } from "./event-utils";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import TimezoneAutocomplete from "@/components/autocomplete/TimezoneAutocomplete.vue";
import moduleCalendarManagement from "@/store/calendar-management/moduleCalendarManagement.js";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import ElomarkUserAutocomplete from "@/components/autocomplete/ElomarkUserAutocomplete.vue";

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    TimezoneAutocomplete,
    flatPickr,
    "v-select": vSelect,
        ElomarkUserAutocomplete,

  },
  data: function() {
    return {
      user_id: null,
      user_role: null,
      login_user_id:null,
          companySearchComponentKey: 0,
      abilities: null,
      added_all_day_checkbox: false,
      updated_all_day_checkbox: false,
      event_resize_or_drop: false,
      UpdateEventPopupActive: false,
      updateSelectedInfo: {},
      update_event_title: null,
      update_event_description: null,
      update_event_start: null,
      update_event_end: null,
      selectInfo: {},
      new_event_title: null,
      new_event_description: null,
      new_event_start: null,
      new_event_end: null,
      configdateTimePicker: {
        enableTime: true,
        // dateFormat: "Y-m-d H:i",
        format: "d/m/Y H:i",
        altFormat: "d/m/Y H:i",
        altInput: true
      },
      newEventPopupActive: false,
      new_events: [],
      userEvents: [],
      user_id: null,
      calendarOptions: {
        eventDrop: this.eventDrop,
        eventResize: this.eventResize,
        timeZone: "Pacific/Wake",
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin // needed for dateClick
        ],
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay"
        },
        allDaySlot: true,
        initialView: "dayGridMonth",
        // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        // select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        // eventsSet: this.handleEvents,
        events: []
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      currentEvents: [],
      defaultSettings: [],
      scheduleAvailabilities: []
    };
  },
  created() {
      var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }

    if (!moduleCalendarManagement.isRegistered) {
      this.$store.registerModule(
        "calendarManagement",
        moduleCalendarManagement
      );
      moduleCalendarManagement.isRegistered = true;
    }

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.login_user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (this.user_role == 'Client Administrator' && this.user_role == 'Client'){
      this.$router.replace("/unauthorized")
    }
  },
  mounted() {
    // this.fetchDefaultSettings();
    this.fetchScheduleAvailabilites();
    this.fetchEvents();
  },
  methods: {
    handleTimeZoneSelected() {
      var selected_time_zone =
        moduleElomarkUserManagement.state.selected_time_zone;
      this.timeZone = selected_time_zone.name.split(" ")[0];
      // console.log(this.timeZone)
    },
    handleWeekendsToggle() {
      this.calendarOptions.weekends = !this.calendarOptions.weekends; // update a property
    },
    handleDateSelect(selectInfo) {
      this.selectInfo = selectInfo;
      this.newEventPopupActive = true;
      // let title = prompt("Please enter a new title for your event");

      this.new_event_start = moment(this.selectInfo.startStr).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      if (this.selectInfo.allDay) {
        this.added_all_day_checkbox = true;
      } else {
        this.added_all_day_checkbox = false;
      }
      this.new_event_end = moment(this.selectInfo.endStr).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    handleEventClick(clickInfo) {
      this.updateSelectedInfo = clickInfo;
      this.fetchEventsByIdFromDB(clickInfo.event.id);
    },
    fetchEventsByIdFromDB(eventId) {
      if (eventId == "") {
        this.$vs.dialog({
          color: "danger",
          title: `Default Settings`,
          text: `You are not allowed to update default settings from here.The changes will be reverted.`
        });
        return;
      }
      this.$store
        .dispatch("calendarManagement/fetchEvent", eventId)
        .then(res => {
          let event = res.data;
          if (event != null) {
            if (this.event_resize_or_drop == true) {
              this.update_event_start = moment(
                this.updateSelectedInfo.event.startStr
              ).format("YYYY-MM-DD HH:mm:ss");

              if (this.updateSelectedInfo.event.allDay == true) {
                this.updated_all_day_checkbox = true;
              } else {
                if (this.updateSelectedInfo.event.endStr == "") {
                  this.update_event_end = this.updateSelectedInfo.event.startStr;
                } else {
                  this.update_event_end = moment(
                    this.updateSelectedInfo.event.endStr
                  ).format("YYYY-MM-DD HH:mm:ss");
                }
                this.updated_all_day_checkbox = false;
              }

              this.allDay = this.updateSelectedInfo.event.allDay;
            } else {
              this.update_event_start = event.start;

              if (this.updateSelectedInfo.event.allDay == true) {
                this.updated_all_day_checkbox = true;
                this.update_event_end = event.start;
              } else {
                this.updated_all_day_checkbox = false;
                this.update_event_end = event.end;
              }
            }
            this.allDay = event.allDay;
            this.update_event_title = event.title;
            this.update_event_description = event.description;
            this.UpdateEventPopupActive = true;
          } else {
            this.$vs.dialog({
              color: "danger",
              title: `Default Settings`,
          text: `You are not allowed to update default settings from here.The changes will be reverted.`
            });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    handleEvents(events) {
      this.currentEvents = events;
    },
    refreshEvents() {
      this.$refs.calendar.$emit("rerender-events");
    },
    updatedAllDay() {
      this.updated_all_day_checkbox = !this.updated_all_day_checkbox;
    },
    addedAllDay() {
      this.added_all_day_checkbox = !this.added_all_day_checkbox;
    },
    searchElomarkUser(inputValue) {
      return this.$store
        .dispatch("elomarkUsersManagement/searchElomarkUser", inputValue)
        .then(response => {
          if (response) {
            let data = moduleElomarkUserManagement.state.elomark_user;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name: data[property].first_name + " " + data[property].surname
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    handleChildEvent() {
      let self = this
      self.elomarkUsers = moduleElomarkUserManagement.state.elomark_users.datas.filter(
            function(ele) {
             self.calendarOptions.events = []
              self.user_id = ele.id
                  self.fetchScheduleAvailabilites();
                  self.fetchEvents();
            console.log(ele.id)
            })
    },
    // fetchDefaultSettings() {
    //   this.$store
    //     .dispatch("calendarManagement/fetchAllDefaultSettings", this.user_id)
    //     .then(res => {
    //       if (res) {
    //         if (res.data != null) {
    //           this.defaultSettings = res.data;
    //           var self = this;
    //           this.defaultSettings.forEach(function(defaultEvent) {
    //             let eventsObj = {};
    //             eventsObj.startRecur = defaultEvent.dow;
    //             eventsObj.daysOfWeek = defaultEvent.dow.split(",");
    //             eventsObj.startRecur = moment(defaultEvent.rangeStart).format(
    //               "YYYY-MM-DD"
    //             );
    //             eventsObj.endRecur = moment(defaultEvent.rangeEnd).format(
    //               "YYYY-MM-DD"
    //             );
    //             eventsObj.startTime = defaultEvent.start_time;
    //             eventsObj.endTime = defaultEvent.end_time;
    //             if (defaultEvent.available == true) {
    //               eventsObj.title = "Available";
    //               eventsObj.className = "available";
    //             } else {
    //               eventsObj.title = "Not Available";
    //               eventsObj.className = "not-available";
    //             }
    //             self.calendarOptions.events.push(eventsObj);
    //           });
    //         }
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       if (err.response.status === 404) {
    //         console.log(err);
    //       }
    //       console.error(err);
    //     });
    // },
    fetchScheduleAvailabilites() {
      this.$store
        .dispatch("calendarManagement/fetchScheduleAvailabilites", this.user_id)
        .then(res => {
          if (res) {
            if (res.data.length != 0) {
              this.scheduleAvailabilities = res.data;
              var self = this;
              this.scheduleAvailabilities.forEach(function(defaultEvent) {
                    let eventsObj = {};
                   eventsObj.start = defaultEvent.start_date + " " + defaultEvent.start_time;
                  eventsObj.end = defaultEvent.end_date + " " + defaultEvent.end_time;
                  eventsObj.allDay = defaultEvent.allDay
                  if (defaultEvent.available == true) {
                    eventsObj.title = "Available";
                    eventsObj.className = "available";
                  } else {
                    eventsObj.title = "Not Available";
                    eventsObj.className = "not-available";
                  }
                  self.calendarOptions.events.push(eventsObj);
              });
            }else{
              this.scheduleAvailabilities = []
            }
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response.status === 404) {
            console.log(err);
          }
          console.error(err);
        });
    },
    fetchEvents() {
      this.$store
        .dispatch("calendarManagement/fetchUserEvents", this.user_id)
        .then(res => {
          if (res) {
          if (res.data.length != 0) {
            let self = this;
            self.userEvents = res.data;
            self.userEvents.forEach(element => {
              self.calendarOptions.events.push(element);
            });
            console.log(this.userEvents);
          }else{
            self.userEvents = [];
          }
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.userEvents = true;
            return;
          }
          console.error(err);
        });
    }
  }
};
</script>

<template>
 <div class="vx-row">
    <vx-card>
  <div class="demo-app">
       <vs-row vs-w="12" class="mb-10">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
        >
          <span class="p-3"> Elomark Users: </span>
          <ElomarkUserAutocomplete style="width:500px"
            :key="companySearchComponentKey"
            :list="searchElomarkUser"
            :searchOn="'elomark_user'"
            @event-name="handleChildEvent"
          ></ElomarkUserAutocomplete>
        </vs-col>
      </vs-row>
    <form>
      <vs-popup
        class="holamundo"
        title='View Event'
        :active.sync="UpdateEventPopupActive"
      >
        <form>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Title</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{update_event_title}}
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Start</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <flat-pickr class="flat-pick"
                :config="configdateTimePicker"
                v-model="update_event_start"
                placeholder="Date Time" :disabled="'disabled'"
              />
              <span class="ml-5">All Day</span>
              <input
                :checked="updated_all_day_checkbox"
                class="ml-2"
                type="checkbox"
                model="updated_all_day_checkbox"
                @change="updatedAllDay"  :disabled="'disabled'"
              />
            </div>
          </div>

          <div class="vx-row mb-6" v-if="!updated_all_day_checkbox">
            <div class="vx-col sm:w-1/3 w-full">
              <span>End</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <flat-pickr  :disabled="'disabled'"
              class="flat-pick"
                :config="configdateTimePicker"
                v-model="update_event_end"
                placeholder="Date Time"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Description</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full description">
             {{update_event_description}}
            </div>
          </div>

        </form>
      </vs-popup>
    </form>




    
    <div class="demo-app-main">
      <FullCalendar
        class="demo-app-calendar"
        ref="calendar"
        :options="calendarOptions"
      >
        <template v-slot:eventContent="arg">
          <b>{{ arg.timeText }}</b>
          <i>{{ arg.event.title }}</i>
        </template>
      </FullCalendar>
    </div>
  </div>
    </vx-card>
      </div>

</template>

<style lang="css">
.flat-pick{
   padding: .7rem;
    border-radius: 5px;
    font-size: 1rem;
    color: #626262;
    cursor: pointer;
}

 


.description .vs-textarea {
  height: 500px;
}
h2 {
  margin: 0;
  font-size: 16px;
}
ul {
  margin: 0;
  padding: 0 0 0 1.5em;
}
li {
  margin: 1.5em 0;
  padding: 0;
}
b {
  /* used for event dates/times */
  margin-right: 3px;
}
.not-available,
.not-available div,
.not-available span {
  background-color: red; /* background color */
  border-color: white; /* border color */
  color: white;
}

.available,
.available div,
.available span {
  background-color: green; /* background color */
  border-color: white; /* border color */
  color: white;
  /* text color */
}
</style>
